import { ShieldCheck } from "lucide-react";
import { daysAgoText } from "@/lib/api";

export function VerifiedBadge({ days, testId = "verified-badge", compact = false }) {
  if (days === null || days === undefined) return null;
  return (
    <span className="lux-verified" data-testid={testId} title="Identity and age verified by our verification partner">
      <ShieldCheck className="h-3.5 w-3.5 text-lux-silverBright" aria-hidden="true" />
      <span className="lux-verified-text">{compact ? `Verified ${days}d` : daysAgoText(days)}</span>
    </span>
  );
}

export function AvailableBadge({ testId = "available-badge" }) {
  return (
    <span className="lux-badge-available" data-testid={testId}>
      <span className="h-1.5 w-1.5 rounded-full bg-lux-success" aria-hidden="true" />
      Available today
    </span>
  );
}

export function DemoTag({ testId = "demo-tag" }) {
  return (
    <span className="lux-tag-demo" data-testid={testId} title="Fictional demo profile for user testing">
      Demo
    </span>
  );
}

const PILL = {
  live: ["Live", "border-lux-success/35 text-lux-success bg-lux-success/10"],
  live_update_in_review: ["Live - update in review", "border-lux-success/35 text-lux-success bg-lux-success/10"],
  in_review: ["In review", "border-lux-warning/35 text-lux-warning bg-lux-warning/10"],
  changes_requested: ["Changes requested", "border-lux-warning/35 text-lux-warning bg-lux-warning/10"],
  rejected: ["Not published", "border-lux-error/35 text-lux-error bg-lux-error/10"],
  suspended: ["Suspended", "border-lux-error/35 text-lux-error bg-lux-error/10"],
  banned: ["Unavailable", "border-lux-error/35 text-lux-error bg-lux-error/10"],
  deletion_pending: ["Deletion scheduled", "border-lux-error/35 text-lux-error bg-lux-error/10"],
  paused: ["Paused", "border-lux-warning/35 text-lux-warning bg-lux-warning/10"],
  expired: ["Expired", "border-lux-border text-lux-muted bg-white/5"],
  reverify: ["Re-verification due", "border-lux-warning/35 text-lux-warning bg-lux-warning/10"],
  unverified: ["Verification needed", "border-lux-warning/35 text-lux-warning bg-lux-warning/10"],
  no_listing: ["No listing yet", "border-lux-border text-lux-muted bg-white/5"],
  draft: ["Draft", "border-lux-border text-lux-muted bg-white/5"],
  pending: ["Pending review", "border-lux-warning/35 text-lux-warning bg-lux-warning/10"],
  approved: ["Approved", "border-lux-success/35 text-lux-success bg-lux-success/10"],
  removed: ["Removed", "border-lux-border text-lux-muted bg-white/5"],
};

export function StatusPill({ status, testId = "advertiser-status-pill", className = "" }) {
  const [label, cls] = PILL[status] || [status, "border-lux-border text-lux-muted"];
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-medium ${cls} ${className}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
      {label}
    </span>
  );
}
